import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function StoreTour() {
  useDocumentMeta('Store Tour | Kjergaard Sports In-Store Selection', 'Take a tour of Kjergaard Sports in Lake Benton, Minnesota. Explore our massive in-store selection of firearms, ammunition, optics, reloading supplies, and safes.');
  const categories = [{
    title: 'Firearms',
    image: 'https://cdn.magicpatterns.com/uploads/h2HHsk76CJxRY2pmsyL8mj/firearms-wall.jpg',
    description: 'Approximately 5,000 new and used firearms on hand.',
    link: '/firearms'
  }, {
    title: 'Ammunition',
    image: 'https://cdn.magicpatterns.com/uploads/w1nfdCex88kVGKJTVUQepJ/ammunition-wall.jpg',
    description: 'A large in-store selection for hunting, target shooting, and personal defense.',
    link: '/ammunition'
  }, {
    title: 'Optics',
    image: 'https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg',
    description: 'Scopes, binoculars, spotting scopes, and rangefinders.',
    link: '/optics'
  }, {
    title: 'Reloading Supplies',
    image: 'https://cdn.magicpatterns.com/uploads/8918DCMwwSgbp8VrUA2ZyG/reloading-supplies.jpg',
    description: 'Bullets, powders, primers, presses, and reloading tools.',
    link: '/reloading-supplies'
  }, {
    title: 'Safes & Accessories',
    image: 'https://cdn.magicpatterns.com/uploads/esrRsJE1XbS5zcQi7PgR9E/safes-display.jpg',
    description: 'Gun safes, cases, cleaning supplies, and shooting accessories.',
    link: '/safes-accessories'
  }, {
    title: 'Hunting Gear & Blinds',
    image: 'https://cdn.magicpatterns.com/uploads/916kAQgnnbRYFKKSKvhkwD/hunting-apparel-gear.jpg',
    description: 'Hunting blinds and outdoor gear for the field.',
    link: '/hunting-gear-blinds'
  }];
  return <div data-id="element-788">
      <PageHero title="Store Tour & In-Store Selection" image="https://cdn.magicpatterns.com/uploads/1BGu7nrTdE3WRCeMKF6WrW/store-tour-wide.jpg" alt="Inside Kjergaard Sports sporting goods store" data-id="element-789" />

      <section className="py-20 bg-brand-offwhite" data-id="element-790">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-791">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-792">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-793">
              Explore Our Massive Inventory
            </h2>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-794">
              Kjergaard Sports is a destination store built for browsing. We
              encourage customers to walk the aisles, handle the equipment, and
              compare options side-by-side. Here is an overview of what you'll
              find when you make the trip to Lake Benton, Minnesota.
            </p>
          </div>

          {/* Store at a Glance Gallery Strip */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-20" data-id="element-795">
            <div className="overflow-hidden rounded-sm shadow-sm" data-id="element-796">
              <img src="https://cdn.magicpatterns.com/uploads/4PEc13YMi3QHpCzosrhrkQ/store-interior-firearms-wide.jpg" alt="Wide view of Kjergaard Sports interior" className="w-full aspect-square object-cover hover:scale-105 transition-transform duration-700" data-id="element-797" />
            </div>
            <div className="overflow-hidden rounded-sm shadow-sm" data-id="element-798">
              <img src="https://cdn.magicpatterns.com/uploads/kENmASH4b2qj4AE9LqDfT7/mounted-rural-detail.jpg" alt="Rural atmosphere and mounted animals at Kjergaard Sports" className="w-full aspect-square object-cover hover:scale-105 transition-transform duration-700" data-id="element-799" />
            </div>
            <div className="overflow-hidden rounded-sm shadow-sm" data-id="element-800">
              <img src="https://cdn.magicpatterns.com/uploads/pByak9UETGkRbYJfr4wRQo/front-entry.jpg" alt="Front entry at Kjergaard Sports" className="w-full aspect-square object-cover hover:scale-105 transition-transform duration-700" data-id="element-801" />
            </div>
            <div className="overflow-hidden rounded-sm shadow-sm" data-id="element-802">
              <img src="https://cdn.magicpatterns.com/uploads/4W49omroAHfAdaTefJNmcK/targets-shooting-supplies.jpg" alt="Shooting supplies and targets" className="w-full aspect-square object-cover hover:scale-105 transition-transform duration-700" data-id="element-803" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-804">
            {categories.map((category, index) => <Link key={index} to={category.link} className="group block bg-brand-bone rounded-sm overflow-hidden border border-brand-cream shadow-sm hover:shadow-md transition-all" data-id="element-805">
                <div className="relative h-64 overflow-hidden" data-id="element-806">
                  <img src={category.image} alt={category.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-807" />
                  <div className="absolute inset-0 bg-brand-charcoal/20 group-hover:bg-transparent transition-colors" data-id="element-808"></div>
                </div>
                <div className="p-6 bg-brand-offwhite" data-id="element-809">
                  <h3 className="text-2xl font-serif text-brand-charcoal mb-2 group-hover:text-brand-hunter transition-colors" data-id="element-810">
                    {category.title}
                  </h3>
                  <p className="text-brand-charcoal/70 mb-4" data-id="element-811">
                    {category.description}
                  </p>
                  <span className="inline-flex items-center text-brand-hunter font-medium" data-id="element-812">
                    View Details <ArrowRight className="w-4 h-4 ml-2" data-id="element-813" />
                  </span>
                </div>
              </Link>)}
          </div>
        </div>
      </section>
    </div>;
}